<script>import { getIcon } from "../data/icons";
const EyeIcon = getIcon("EyeIcon");
</script>

{#if typeof EyeIcon === 'string'}
	<img src={EyeIcon} alt={$t(Verbiage.icon_alt, 'alts')} />
{:else if typeof EyeIcon === 'function'}
	<svelte:component this={EyeIcon} />
{:else}
	<span>Invalid icon</span>
{/if}

<style>
</style>
